<div>
    <app-tool-bar [title]="'Manage Hostel Categories'" [iconName]="'pi-building'" [isAdd]="true"
        (handleAdd)="handleHostel()"></app-tool-bar>
</div>
<div class="p-4 overflow-auto h-[85vh]">
    <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="loadData($event)" [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined"
        [loading]="loading">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 5rem">
                    S.No
                </th>
                <th *ngFor="let col of columns" [pSortableColumn]="col.sortable ? col.field : ''">
                    {{ col.header }}
                    <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
                <td>
                    <div style="margin-left: 5px;">
                        {{ rowIndex + 1 }}
                    </div>
                </td>
                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.type">

                        <!-- Facilities -->
                        <ng-container *ngSwitchCase="'facilities'">
                            <span class="text-sm">{{ rowData[col.field] }}</span>
                        </ng-container>

                         <ng-container *ngSwitchCase="'fee_amount'">
                            <span>{{ rowData[col.field] | currency: rowData.currency }}</span>
                        </ng-container>

                        <!-- Handle Actions -->
                        <ng-container *ngSwitchCase="'actions'">
                            <div *ngIf="!loading" (click)="setHostelEditData(rowData)">
                                <p-menu [tabindex]="undefined" #menu [model]="HostelActionItems" [popup]="true"
                                    appendTo="body"></p-menu>
                                <button pButton type="button" (click)="menu.toggle($event)" icon="pi pi-ellipsis-v"
                                    class="p-button-rounded p-button-text"></button>
                            </div>
                        </ng-container>

                        <!-- Default Case (Normal Field) -->
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="loading">
            <tr>
                <td colspan="3" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <!-- when data length is 0 -->
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columns.length + 1" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>

<p-dialog [modal]="true" *ngIf="isAddHostel" [(visible)]="isAddHostel"
    [breakpoints]="{ '1199px': '70vw', '575px': '90vw' }" closable="false" [style]="{ width: '60vw' }"
    [draggable]="false" [resizable]="false">
    <app-create-hostel (closeDialog)="isAddHostel = false"
        (reload)="reloadData()"></app-create-hostel>
</p-dialog>

<p-dialog [modal]="true"
*ngIf="isEditHostel"
[(visible)]="isEditHostel" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '60vw' }" [draggable]="false" [resizable]="false">
    <app-create-hostel (closeDialog)="isEditHostel = false" [type]="'Update'"
    [hostelData]="hostelData"
        (reload)="reloadData()"></app-create-hostel>
</p-dialog>

<p-dialog [modal]="true"
*ngIf="isDeleteHostel"
[(visible)]="isDeleteHostel" [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">

    <app-delete-hostel (closeDialog)="isDeleteHostel = false"
    [hostelData]="hostelData"
        (reload)="reloadData()"></app-delete-hostel>

</p-dialog>
